import axios from 'axios'
import { ProfileValidationParameters, ProfileValidationResult, Profile } from '../features/profile/types'

export const fetchProfiles = (
  limit: number,
  offset: number,
  sid: string,
  appearance: string,
  age: string,
  hair: string,
  breast: string,
  skin: string,
  size: string
) =>
  axios.get(
    `/profiles?limit=${limit}&offset=${offset}&sid=${sid}&appearance=${appearance}&age=${age}&hair=${hair}&breast=${breast}&skin=${skin}&size=${size}`
  )

export const getPhotofromId = (entityId: string) => axios.get(`/photo/${entityId}`)

export const fetchProfileInfo = (sid: string, profileId: number) => axios.get(`/profiles/${profileId}?sid=${sid}`)

export const validateProfile = (profile: ProfileValidationParameters) =>
  axios.post<ProfileValidationResult>('/profiles/validate', profile)

export const saveProfile = (profile: ProfileValidationParameters) => axios.post<Profile>('/profiles', profile)

export const updateProfile = (entityId: string, data: ProfileValidationParameters) =>
  axios.put<Profile>(`/profiles/${entityId}`, data)

export const sendPhoto = (data: FormData) => axios.post('/profiles/photo', data)

export const updatePhoto = (id: string, data: FormData) => axios.post(`/profiles/updatephoto/${id}`, data)
